import { render, staticRenderFns } from "./BrightStock.vue?vue&type=template&id=af7e6e2c"
import script from "./BrightStock.vue?vue&type=script&lang=js"
export * from "./BrightStock.vue?vue&type=script&lang=js"
import style0 from "./BrightStock.vue?vue&type=style&index=0&id=af7e6e2c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports